if (!customElements.get('accessories-bundle')) {
  class AccessoriesBundle extends HTMLElement {
    constructor() {
      super();
      this.initialize();
    }

    initialize() {
      this.addEventListener('change', () => this.notifyChange());
      this.attachEventListeners([
        { selector: '.variant-selector', event: 'change', handler: this.handleVariantChange.bind(this) },
        { selector: '.update-accessory', event: 'click', handler: this.handleClickUpdateBtn.bind(this) },
        { selector: '.add-accessory', event: 'click', handler: this.handleClickUpdateBtn.bind(this) },
        { selector: '.return-btn', event: 'click', handler: AccessoriesBundle.handleCancelBtnClick },
      ]);
    }

    attachEventListeners(events) {
      events.forEach(({ selector, event, handler }) => {
        const elements = this.querySelectorAll(selector);
        elements.forEach((element) => {
          element.addEventListener(event, handler);
        });
      });
    }

    handleVariantChange(event) {
      const selectedOption = event.target.options[event.target.selectedIndex];
      const listItem = event.target.closest('li');

      if (!listItem || !selectedOption) return;

      const variantId = selectedOption.value;
      const imageUrl = selectedOption.getAttribute('data-image');
      const price = selectedOption.getAttribute('data-price');

      listItem.querySelectorAll('.variant-selector').forEach((selector) => {
        selector.value = variantId;
      });

      const accessoryImg = listItem.querySelector('.accessory-img');
      if (accessoryImg) {
        accessoryImg.src = imageUrl;
      }

      listItem.setAttribute('data-variantid', variantId);
      listItem.dataset.price = selectedOption.dataset.priceCents;
      listItem.dataset.comparePrice = selectedOption.dataset.compareCents;
      listItem.classList.toggle('free', Number(selectedOption.dataset.priceCents) === 0);
      listItem.querySelectorAll('.price__default .price__current, .price__default .price__free').forEach((priceElement) => {
        priceElement.classList.toggle('price__free', Number(selectedOption.dataset.priceCents) === 0);
        priceElement.classList.toggle('price__current', Number(selectedOption.dataset.priceCents) !== 0);
        priceElement.textContent = price;
      });
      listItem.querySelectorAll('.price__was').forEach((element) => {
        element.textContent = selectedOption.dataset.comparePrice;
      });
      listItem.querySelectorAll('.price').forEach((element) => {
        element.classList.toggle('price--on-sale', Number(listItem.dataset.comparePrice) > Number(listItem.dataset.price));
      });
      this.notifyChange();
    }

    notifyChange() {
      this.dispatchEvent(new CustomEvent('on:bundle:change', { bubbles: true }));
    }

    getSelectedItems(quantity = 1) {
      return Array.from(this.querySelectorAll('.accessory'))
        .filter((item) => item.querySelector('.accessory-checkbox:checked') && item.dataset.variantid)
        .map((item) => ({ id: item.dataset.variantid, quantity }));
    }

    getTotals() {
      return Array.from(this.querySelectorAll('.accessory')).reduce((total, item) => {
        if (item.querySelector('.accessory-checkbox:checked')) {
          const price = Number(item.dataset.price) || 0;
          total.price += price;
          total.compare += Math.max(price, Number(item.dataset.comparePrice) || 0);
        }
        return total;
      }, { price: 0, compare: 0 });
    }

    updateQuantity(quantity) {
      this.querySelectorAll('[data-bundle-quantity]').forEach((element) => {
        element.textContent = `× ${quantity}`;
      });
    }

    handleClickUpdateBtn(event) {
      const listItem = event.target.closest('li');
      if (!listItem) return;

      const checkbox = listItem.querySelector('.accessory-checkbox');
      if (checkbox) {
        checkbox.checked = true;
        checkbox.setAttribute('aria-checked', 'true');
        this.notifyChange();
      }

      AccessoriesBundle.handleCancelBtnClick(event);
    }

    static handleCancelBtnClick(event) {
      const sideDrawer = event.target.closest('side-drawer');
      if (sideDrawer) {
        sideDrawer.close();
      }
    }
  }

  customElements.define('accessories-bundle', AccessoriesBundle);
}
